
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"12","viewBox":"0 0 11 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 9.99998C0 8.34314 1.34314 7 2.99998 7H7.79995C9.45679 7 10.7999 8.34314 10.7999 9.99998V11.2C10.7999 11.5313 10.5313 11.8 10.1999 11.8C9.86856 11.8 9.59993 11.5313 9.59993 11.2V9.99998C9.59993 9.00587 8.79405 8.19999 7.79995 8.19999H2.99998C2.00587 8.19999 1.19999 9.00587 1.19999 9.99998V11.2C1.19999 11.5313 0.931365 11.8 0.599996 11.8C0.268627 11.8 0 11.5313 0 11.2V9.99998Z","fill":"white"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 2.99998C2 1.34314 3.34314 0 4.99998 0C6.65682 0 7.99996 1.34314 7.99996 2.99998C7.99996 4.65682 6.65682 5.99996 4.99998 5.99996C3.34314 5.99996 2 4.65682 2 2.99998ZM4.99998 1.19999C4.00587 1.19999 3.19999 2.00587 3.19999 2.99998C3.19999 3.99409 4.00587 4.79997 4.99998 4.79997C5.99409 4.79997 6.79997 3.99409 6.79997 2.99998C6.79997 2.00587 5.99409 1.19999 4.99998 1.19999Z","fill":"white"}})])
          )
        }
      }
    